import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutCommodityList extends Layout {
    layoutheaderCommodityList: LayoutHeader;
    sourceCommodity: DataSource;
    tableCommodity: Table;
}
